// extracted by mini-css-extract-plugin
export default {"container":"VXNa3D","text":"Y9_gFj","buttonContainer":"I_sl8e"};